import type { PermissionData } from '../types'

export function computeShareLocationPermission(permissionData: PermissionData) {
  if (permissionData.rmOnly) return 'hidden'

  return 'enabled'
}
